<template>
  <div class="tooltips">
    <div class="tips-link" @mouseover="onHover" @mouseleave="onLeave">
      <img :src="icon" :alt="iconAlt" class="ico-bace ico-s" />
      <a class="tips-link-txt">{{ message }}</a>
    </div>

    <div
      class="tips-area"
      :style="{
        display: isHover ? 'flex' : 'none',
      }"
    >
      <div v-if="tipImage" class="tips-img col-5">
        <img :src="tipImage" :alt="tipImageAlt" />
      </div>
      <div class="tips-txt col">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { TipIcon } from "icons";

export default {
  name: "Tooltip",
  props: {
    icon: {
      type: String,
      default: TipIcon,
    },
    iconAlt: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: "",
    },
    tipImage: {
      type: String,
      default: "",
    },
    tipImageAlt: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isHover: false,
    };
  },
  methods: {
    onHover() {
      this.isHover = true;
    },
    onLeave() {
      this.isHover = false;
    },
  },
};
</script>
